// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SortIcons_wrapper__1ppJv"};